const customScroll = () => {
  const getCoords = elem => {
    // crossbrowser version
    const box = elem.getBoundingClientRect();

    const { body } = document;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft =
      window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left), box };
  };
  let lastKnownScrollPosition = 0;
  let ticking = false;

  function doSomething() {
    window.coords = [];
    const steps = document.querySelectorAll('.c-filter-form');
    [].forEach.call(steps, menu => {
      const coords = getCoords(menu);
      if (coords.box.height > 0) {
        /* eslint-disable */
        window.coords.push(coords.top);
      }
      /* eslint-enable */
    });
    let title = false;
    if (window.coords.length && window.scrollY > window.coords[0]) {
      document.querySelectorAll('.js-prev-section').forEach(elem => {
        /* eslint-disable */
        elem.style.display = 'block';
        /* eslint-enable */
      });
      title = document.querySelector(
        '.c-children-menu--mobile .c-select__title',
      );
      if (title) {
        title.classList.add('is-shorter');
      }
    } else {
      document.querySelectorAll('.js-prev-section').forEach(elem => {
        /* eslint-disable */
        elem.style.display = 'none';
        /* eslint-enable */
      });
      title = document.querySelector(
        '.c-children-menu--mobile .c-select__title',
      );
      if (title) {
        title.classList.remove('is-shorter');
      }
    }
  }

  document.addEventListener('scroll', () => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        doSomething(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });
  document.querySelectorAll('.js-prev-section').forEach(elem => {
    elem.addEventListener('click', () => {
      let top = window.coords[0];
      window.coords.forEach(e => {
        if (e < window.scrollY) {
          top = e;
        }
      });
      if (window.innerWidth > 768) {
        window.scrollTo(0, top - 116);
      } else {
        window.scrollTo(0, top - 247);
      }
    });
  });
};

export default customScroll;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/customscroll.js